import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from './session.service';

@Injectable()
export class SessionAuthInterceptor implements HttpInterceptor {
  private isLoggingOut = false;

  constructor(private sessionService: SessionService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const message =
          typeof error?.error?.message === 'string' ? error.error.message : '';

        const isSessionExpired =
          error.status === 401 ||
          message === 'token expired' ||
          message === 'Token has expired. Please log in again.' ||
          message.toLowerCase().includes('session expired');

        if (!this.isLoggingOut && isSessionExpired) {
          this.isLoggingOut = true;
          sessionStorage.setItem('isLoggingOut', 'true');
          this.sessionService.logout();
        }

        return throwError(() => error);
      })
    );
  }
}
